import React, { forwardRef } from 'react';

import type { InputBaseProps } from '@mui/material';
import { InputBase } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

interface InputStyles {
  height: number | string;
  margin: number | string;
  width: number | string;
}

interface ToolbarInputProps extends InputBaseProps {
  disableColor?: boolean;
  inputStyles?: InputStyles;
  open?: boolean;
}

const useStyles = makeStyles<Pick<ToolbarInputProps, 'disableColor' | 'inputStyles' | 'open'>>()(
  (theme, { disableColor, inputStyles, open }) => ({
    input: {
      boxSizing: 'border-box',
    },
    root: {
      color: open && !disableColor ? theme.palette.primary.main : undefined,
      ...inputStyles,
    },
  })
);

/**
 * This component is for use with the ToolbarSelect component.  It's really not
 * for general use.  See specific notes below. We do not spread inputStyles to
 * InputBase to suppress a warning in React that inputStyles is not a valid DOM
 * attribute applied to the native input. Do NOT remove the {...rest} spread
 * operator as Material-UI injects props into this component from ToolbarSelect
 * that we need to pass down.
 */
export const ToolbarInput = forwardRef(function ToolbarInput(
  props: ToolbarInputProps,
  ref
): JSX.Element {
  const { disableColor, inputStyles, open, ...rest } = props;
  const { classes } = useStyles({ disableColor, inputStyles, open });

  return <InputBase ref={ref} classes={{ input: classes.input, root: classes.root }} {...rest} />;
});
